import { ReceiveMessageBody, WebSocketMessageTypes } from '@/websocket/types'
import { WebSocketMessageMode } from '@/websocket/constants'
import WebSocketReceiver from '@/websocket/receivers/receiver'

export const enum WebSocketEcgMessageTypes {
  ECG_SEND = 'ecg_send',
  PR_SEND = 'pr_send'
}

export default class EcgWebSocketReceiver extends WebSocketReceiver<
  WebSocketMessageMode.ECG
> {
  handleMessage(
    messageBody: ReceiveMessageBody<
      WebSocketMessageMode.ECG,
      WebSocketMessageTypes<WebSocketMessageMode.ECG>
    >
  ) {
    if (!messageBody) {
      return
    }

    switch (messageBody.type) {
      case WebSocketEcgMessageTypes.ECG_SEND:
        this.events.emit(WebSocketEcgMessageTypes.ECG_SEND, messageBody)
        break
      case WebSocketEcgMessageTypes.PR_SEND:
        this.events.emit(WebSocketEcgMessageTypes.PR_SEND, messageBody)
        break
      default:
        break
    }
  }
}
